import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useBookkeepingItemsContext } from '../../../../../../../contexts/bookkeepingItemsContext'
import { SearchWithFilters } from '../../../../../../SearchWithFilters'
import { BookkeepingItemsFiltersPanel } from './elements/BookkeepingItemsFiltersPanel/BookkeepingItemsFiltersPanel'

export const BookkeepingItemsSearch = (): ReactElement => {
  const { t } = useTranslation()
  const { filters, setFilters } = useBookkeepingItemsContext()

  const handleSearchChange = useCallback(
    (value: string | undefined) => {
      setFilters({ searchQuery: value })
    },
    [setFilters],
  )

  return (
    <SearchWithFilters
      searchQuery={filters.searchQuery}
      onSearchChange={handleSearchChange}
      searchPlaceholder={t('bank_transactions.drawer.search_placeholder')}
      filtersPanel={<BookkeepingItemsFiltersPanel />}
    />
  )
}
